<template>
  <div
    class="w-full h-full flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8"
  >
    <div class="max-w-md w-full space-y-8">
      <div>
        <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
          {{ t("login.title") }}
        </h2>
        <p class="mt-2 text-center text-sm text-gray-600">
          {{ t("login.subtitle") }}
        </p>
      </div>

      <div
        v-if="error"
        class="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded relative"
      >
        <span class="block sm:inline">{{ t("login.error") }}</span>
      </div>

      <div class="mt-8 space-y-6">
        <Button
          class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          :disabled="loading"
          @click="loginWithKeycloak"
        >
          <Loader2 v-if="loading" class="mr-2 animate-spin text-white" />
          {{ t("login.button") }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Button } from "~/components/ui/button";
import { Loader2 } from "lucide-vue-next";

useHead({
  title: "Digitax - Login",
});
definePageMeta({
  auth: false,
  layout: "fullpage"
});

const route = useRoute();
const { openInPopup } = useUserSession();
const { t } = useI18n();

const loading = ref(false);
const error = computed(() => route.query.error === "oauth_error");

async function loginWithKeycloak() {
  try {
    loading.value = true;
    openInPopup("/auth/keycloak");
  } catch (err) {
    console.error("Login error:", err);
  } finally {
    loading.value = false;
  }
}

const { loggedIn } = useUserSession();
watch(
  loggedIn,
  (isLoggedIn) => {
    if (isLoggedIn) {
      navigateTo("/");
    }
  },
  { immediate: true }
);
</script>
